/** @format */

import React from "react";
import { useAuth } from "../contexts/AuthContext";

interface EmbargoOverlayProps {
  message?: string;
}

const EmbargoOverlay: React.FC<EmbargoOverlayProps> = ({ message }) => {
  const { isEmbargoed, logout } = useAuth();

  if (!isEmbargoed) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="bg-white max-w-md w-[90%] rounded-lg shadow-xl p-6 text-center">
        <h2 className="text-xl font-bold mb-3">You're signed in somewhere else</h2>
        <p className="text-gray-700 mb-4">
          {message ||
            "Your account is currently active on another device or browser. To continue here, sign out and log in again after the other session ends."}
        </p>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={logout}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmbargoOverlay;


